export const siteMetadata = () => {
    const data = {
        site: {
            siteMetadata: {
                title: 'Hesburgh Component Library',
                image: '/images/fakeimage.png',
                description: 'Component library for the Hesburgh Libraries',
                twitterUsername: 'hlibraries',
                siteUrl: 'https://www.library.nd.edu',
                nofollow: false,
                noindex: false,
            },
        },
    };
    return data.site.siteMetadata;
};
